"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductTree = void 0;
const react_1 = require("@apollo/client/react");
const client_utils_1 = require("../../client.utils");
const gql_1 = require("../gql");
const useProductTree = (catalogId, nodeId, options) => {
    const { networkStatus, data, error, } = (0, react_1.useQuery)(gql_1.GET_PRODUCT_TREE, {
        skip: !catalogId || !nodeId || (options === null || options === void 0 ? void 0 : options.skip),
        variables: { nodeId, catalogId },
        fetchPolicy: 'cache-first',
    });
    return {
        data,
        error,
        isLoading: (0, client_utils_1.isQueryLoading)(networkStatus),
    };
};
exports.useProductTree = useProductTree;
exports.default = exports.useProductTree;
